import i18n from "@/i18n";

// Backend (Api::ChatController) emits SSE error events with a stable code.
// Keys live in client/public/locales/<lng>/common.json under chat.errors.<code>.
export const CHAT_ERROR_CODES = ["connection", "rateLimited", "generic", "iterationCap"] as const;
export type ChatErrorCode = (typeof CHAT_ERROR_CODES)[number];

export function translateChatError(code: unknown): string {
  if (typeof code === "string" && (CHAT_ERROR_CODES as readonly string[]).includes(code)) {
    return i18n.t(`chat.errors.${code as ChatErrorCode}`);
  }
  return i18n.t("chat.errors.generic");
}
